// A plugin's code load right after a reload can take longer than one step on a busy page (G4, 2026-10-20: eight
// plugins stayed in error for the whole session). The same load is waited for step by step, with a call per
// step; only a load that has not settled after every step fails, with `message`.
export function waitPatiently(promise, { stepMs, steps, message, onSlow }) {
  return new Promise((resolve, reject) => {
    let waited = 0
    let timer
    const tick = () => {
      waited += stepMs
      if (waited >= stepMs * steps) {
        reject(new Error(message))
        return
      }
      onSlow?.(waited)
      timer = setTimeout(tick, stepMs)
    }
    timer = setTimeout(tick, stepMs)
    promise.then(
      (v) => {
        clearTimeout(timer)
        resolve(v)
      },
      (e) => {
        clearTimeout(timer)
        reject(e)
      }
    )
  })
}

// One task turn, so a waiting message (a tab visit from the side panel) runs between two plugin starts; a chain
// of awaits alone never lets it in. Not scheduler.yield(): Chrome runs its continuation before other waiting tasks.
export function yieldToTasks() {
  return new Promise((resolve) => {
    const { port1, port2 } = new MessageChannel()
    port1.onmessage = () => {
      port1.close()
      resolve()
    }
    port2.postMessage(null)
  })
}
